import { IComponentOptions, IController } from 'angular';
import './gmc-footer.component.scss';
import { ModalService } from '../../../../components/modals/gmc-modal/gmc-modal.service';
import { PublicModalTypes } from '../';

class GmcFooterController implements IController {
  static $inject = [
    'ModalService'
  ];

  constructor( private modalService: ModalService ) {

  }

  showModal( type: PublicModalTypes ) {
    (async () => {
      await this.modalService.showModal({
        backdrop: true,
        component: 'publicAdditionalModal',
        data: {
          type
        }
      });
    })();
  }
}

export const GmcFooterComponent: IComponentOptions = {
  controller: GmcFooterController,
  template: require('./gmc-footer.component.html')
};



// WEBPACK FOOTER //
// ./app/states/public/components/public-footer/gmc-footer.component.ts